type useGetCurrentOrganizationLocationReturnType = [
  {
    currentOrganizationCoreId: string | null;
    currentLocationCoreId: string | null;
  },
  (orgCoreId: string | null, locCoreId: string | null) => void,
];

export const useGetCurrentOrganizationLocation: () => useGetCurrentOrganizationLocationReturnType =
  () => {
    const currentOrganizationCoreId = localStorage.getItem(
      'currentOrganizationCoreId',
    );
    const currentLocationCoreId = localStorage.getItem('currentLocationCoreId');

    const setCurrentOrganizationLocation = (
      orgCoreId: string | null,
      locCoreId: string | null,
    ) => {
      if (orgCoreId === null) {
        localStorage.removeItem('currentOrganizationCoreId');
      } else {
        localStorage.setItem('currentOrganizationCoreId', orgCoreId);
      }

      if (locCoreId === null) {
        localStorage.removeItem('currentLocationCoreId');
      } else {
        localStorage.setItem('currentLocationCoreId', locCoreId);
      }
    };

    return [
      { currentOrganizationCoreId, currentLocationCoreId },
      setCurrentOrganizationLocation,
    ];
  };

export default useGetCurrentOrganizationLocation;
